// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__jb2wy","dragIcon":"Choice_dragIcon__1acyb","left":"Choice_left__15slT","input":"Choice_input__36BBd"};